export * from './inquiry'


export const personaBaseUrl = import.meta.env.VITE_VIRTUAL_CARD_BASE_URL